import React, { useEffect, useRef, useState } from "react";
import { doPostMessage } from "../utils/rn";
import { Renderer, Stave, EasyScore, System, Factory, StaveNote, Voice, Formatter } from "vexflow4";
import SingleStaveHandler from "../common/singleStaveHandler";
import 'weui';
import 'react-weui-ts/build/dist/react-weui.css';


const Rhythm = () => {
    useEffect(() => {
        const div = document.getElementById('output');
        const renderer = new Renderer((div as HTMLDivElement), Renderer.Backends.SVG);

        renderer.resize(500, 500);
        const context = renderer.getContext();

        const stave = new Stave(10, 40, 400);

        stave.addClef('treble').addTimeSignature('4/4');

        stave.setContext(context).draw();

        const notes = [
            // A quarter-note C.
            new StaveNote({
                keys: ['c/4'],
                duration: 'q'
            }),

            // A quarter-note D.
            new StaveNote({
                keys: ['d/4'],
                duration: 'q'
            }),

            // A quarter-note rest. Note that the key (b/4) specifies the vertical
            // position of the rest.
            new StaveNote({
                keys: ['b/4'],
                duration: 'qr'
            }),

            // A C-Major chord.
            new StaveNote({
                keys: ['c/4', 'e/4', 'g/4'],
                duration: 'q'
            }),
        ];

        const voice = new Voice({
            num_beats: 4,
            beat_value: 4
        });
        voice.addTickables(notes);

        new Formatter().joinVoices([voice]).format([voice], 250);

        voice.draw(context, stave);

    }, [])

    return (
        <>
            <div id={"output"}>
            </div>
        </>
    );
};

export default Rhythm;
